import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import PromotionalBanner from './PromotionalBanner';
import { SIGNUP_URL } from '../utils/constants';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  // Handle sign in
  const handleSignIn = () => {
    const redirectUri = encodeURIComponent('https://dashboard.personalia.io/login');
    window.location.href = `https://auth.personalia.io/login?client_id=6ml65rcl99mckt1s3uu5p6smkh&scope=openid+profile+aws.cognito.signin.user.admin&response_type=code&scope=openid+profile&redirect_uri=${redirectUri}`;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-sm">
      <PromotionalBanner />
      <div className="container-custom py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link href="/" className="flex items-center">
            <Image
              src="/images/PERSONALIA-PRIMARY-LOGO-DARK_RGB-300x68.png"
              alt="Personalia Logo"
              width={150}
              height={34}
              className="h-auto"
              priority
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <div className="flex items-center space-x-4">
              <Link href="/why-personalia" className="text-gray-700 hover:text-primary transition-colors">
                Why Personalia
              </Link>
              <Link href="/integrations" className="text-gray-700 hover:text-primary transition-colors">
                Integration & API
              </Link>
              <Link href="/pricing" className="text-gray-700 hover:text-primary transition-colors">
                Pricing
              </Link>
              <Link href="/articles" className="text-gray-700 hover:text-primary transition-colors">
                Articles
              </Link>
              <Link href="https://help.xmpie.com/Personalia/en/index.htm#t=Overview.htm" className="text-gray-700 hover:text-primary transition-colors flex items-center">
                Docs
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </Link>
              <Link href="/contact" className="text-gray-700 hover:text-primary transition-colors">
                Contact
              </Link>
            </div>

            <div className="flex items-center space-x-4">
              <button 
                onClick={handleSignIn}
                className="btn btn-outline flex items-center"
              >
                Sign In
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </button>
              <a
                href={SIGNUP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary flex items-center whitespace-nowrap"
              >
                Join for free
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="text-gray-500 hover:text-gray-600 focus:outline-none"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 py-4">
          <div className="container-custom">
            <nav className="flex flex-col space-y-4">
              <Link href="/why-personalia" className="text-gray-700 hover:text-primary transition-colors py-2">
                Why Personalia
              </Link>
              <Link href="/integrations" className="text-gray-700 hover:text-primary transition-colors py-2">
                Integration & API
              </Link>
              <Link href="/pricing" className="text-gray-700 hover:text-primary transition-colors py-2">
                Pricing
              </Link>
              <Link href="/articles" className="text-gray-700 hover:text-primary transition-colors py-2">
                Articles
              </Link>
              <Link href="https://help.xmpie.com/Personalia/en/index.htm#t=Overview.htm" className="text-gray-700 hover:text-primary transition-colors py-2 flex items-center">
                Docs
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </Link>
              <Link href="/contact" className="text-gray-700 hover:text-primary transition-colors py-2">
                Contact
              </Link>
              <button 
                onClick={handleSignIn}
                className="w-full text-left text-gray-700 hover:text-primary transition-colors py-2 flex items-center"
              >
                Sign In
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </button>
              <a
                href={SIGNUP_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsMenuOpen(false)}
                className="btn btn-primary flex items-center justify-center w-full"
              >
                Join for free
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </nav>
          </div>
        </div>
      )}

      {/* Segment Navigation */}
      <div className="bg-gray-50 py-4 border-t border-gray-100">
        <div className="container-custom">
          <div className="segment-nav">
            <Link href="/for-creative-authorities" className="segment-nav-item hover:bg-primary hover:text-white">
              For Creative Authorities
            </Link>
            <Link href="/for-infrastructure-engineers" className="segment-nav-item hover:bg-primary hover:text-white">
              For Infrastructure Engineers
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
